import axiosTokenInstance from 'services/api/backoffice';
import {
  REPORT_TRANSACTIONS_CHARGEBACK_SUCCESS,
  REPORT_TRANSACTIONS_CHARGEBACK_FAILURE,
} from '_models/redux/types';

// Función de acción
export const actionReportTransactionsChargeback = (params) => async (dispatch) => {
  const { descriptionTransaction, txn_payment_id, payment_provider_name } = params || {};
  // Endpoint: Try & Catch
  try {
    const response = await axiosTokenInstance.post(`api/reports/transactions/chargeback`, {
      reason: descriptionTransaction,
      txn_payment_id: parseInt(txn_payment_id),
      payment_provider_name: payment_provider_name,
    });

    const { data, status } = response || {};

    dispatch({
      type: REPORT_TRANSACTIONS_CHARGEBACK_SUCCESS,
      payload: data || {},
      status: status || {},
      method: 'post',
    });
  } catch (e) {
    dispatch({
      type: REPORT_TRANSACTIONS_CHARGEBACK_FAILURE,
      payload: e || {},
    });
  }
};
